import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { RecursoCampanhaSelectComponent } from './recurso-campanha-select.component';
import { RecursoCampanhaSelectTipoFilterPipe } from './recurso-campanha-select-tipo-filter.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RecursoCampanhaSelectComponent,
        RecursoCampanhaSelectTipoFilterPipe
    ],
    exports: [
        RecursoCampanhaSelectComponent,
        RecursoCampanhaSelectTipoFilterPipe
    ],
    providers: [
        RecursoCampanhaSelectTipoFilterPipe
    ]
})
export class RecursoCampanhaSelectModule { }
